<span class="wo-inline-label">
  <span class="wo-inline-label-title">{{ label }}</span>
  <span>{{ value }}</span>
</span>
